(function ($) {
  'use strict'

  Drupal.behaviors.mobileMenu = {
    attach: function (context) {
      $('.mobile-menu-target-wrapper', context).append($('.menu--main > ul.menu').clone().addClass('mobile-main'))
      $('.mobile-menu-target-wrapper', context).append($('.menu--header-button > ul.menu').clone().addClass('mobile-button'))

      $('.menu-toggler', context).click(function () {
        if ($('body').hasClass('menu-open')) {
          $('body').removeClass('menu-open')
        }
        else {
          $('body').addClass('menu-open')
        }
        return false
      })

      $('.closer').click(function () {
        $('body').removeClass('menu-open')
        return false
      });

      $('.menu-blinder').click(function () {
        $('body').removeClass('menu-open')
        return false;
      })
    }
  }
})(jQuery)
